import { Regulars } from '@/shared/constants/regulars.constant';

export const validateEmail = (
	email: string,
	errorMessage = 'Email is required and must be in a valid format (e.g., user@example.com).',
) => {
	if (!email) {
		return errorMessage;
	}

	if (!Regulars.CyrillicPattern.test(email)) {
		return errorMessage;
	}

	if (email.length > 50 || !email.match(Regulars.Email)) {
		return errorMessage;
	}

	return '';
};
